import React, { useEffect, useMemo, useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { LabelProps } from "../../../../../utils/types";
import { Label } from "../../../../../stories/Label/Label";
import Input from "../../../../../stories/Input/Input";
import Yes from "../../../../../images/ApprovedStatus.svg";
import { GetItemNodeForStockEntryViewAsset } from "../../masters/items/queries/queries";
import { useLazyQuery } from "@apollo/client";
import { AtsStckItem } from "../../masters/items/queries/types";
import { nodeVar } from "../../../../../utils/commonQueryTypes";

import { optionsType, ViewItemForm, ViewItemFormType } from "../../../../../utils/formTypes";
import useLabels from "../../../../../customHooks/useLabels";
import useFormJson from "../../../../../json/useFormJson";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  itemId: number;
}
const ViewAsset = ({ setModalFlag, itemId }: Props) => {
  
const {StockEntry}=useFormJson();
  const [GetItem, { data }] = useLazyQuery<{ node: AtsStckItem }, nodeVar>(
    GetItemNodeForStockEntryViewAsset
  );
  const assetConfigurations: optionsType[] = [
    { label: "Track Serial", value: "trackSerial" },
    { label: "Track Brand", value: "trackBrand" },
    { label: "Track Model", value: "trackModel" },
    { label: "Track Batch", value: "trackBatch" },
    { label: "Track Expiry", value: "trackExpiry" },
    { label: "Track Warranty", value: "trackWarranty" },
    { label: "Track Installation", value: "trackInstallation" },
    { label: "Track Maintenance", value: "trackMaintenance" },
    { label: "Is Perishable", value: "isPerishable" },
    { label: "Is Consumable", value: "isConsumable" },
    { label: "Image Needed", value: "imageNeeded" },
    { label: "Track AMC", value: "trackAmc" },
    { label: "Track Geo Location", value: "trackGeoLocation" },
    { label: "Track Insurance", value: "trackInsurance" },
    { label: "Is Module", value: "isModule" },
    { label: "Is Component", value: "isComponent" },
    {
      label: "Stock Details Entry Not Needed",
      value: "stckDetailsEntryNotNeeded",
    },
    {
      label: "Stock Details Entry Is Single",
      value: "stckDetailsEntryIsSingle",
    },
    {
      label: "Stock Details Entry Is Multiple",
      value: "stckDetailsEntryIsMultiple",
    },
    { label: "Additional Property Needed", value: "additionalPropertyNeeded" },
  ];

  const enabledConfigs = useMemo(() => {
    return assetConfigurations.filter((config) => {
      if (data) {
        return (data.node as unknown as Record<string, boolean>)[
          `${config.value}`
        ];
      } else {
        return false;
      }
    });
  }, [data, assetConfigurations]);

  const initialValues:ViewItemForm = {
    description: "",
    code: "",
    gst_applicable: "",
    category: "",
    sub_category: "",
    uom: "",
    model: "",
  };

  const [formState, setFormState] = useState<ViewItemForm>(initialValues);

  useEffect(() => {
    if (itemId) {
      GetItem({
        variables: {
          id: itemId,
          
        },
      }).then(({ data }) => {
        if (data && data.node) {
          const { desc, categoryDetails, code, uom, enableGst } = data.node;

          setFormState({
            category: categoryDetails.categoryName,
            code,
            description: desc,
            gst_applicable: enableGst ? "Applicable" : "Not Applicable",
            model: "",
            sub_category: "",
            uom: uom,
          });
        }
      });
    } else {
      setFormState(initialValues);
    }
  }, [GetItem, itemId, data]);

  const {itemLabel}=useLabels();

  return (
    <>
      <div className="view-asset">
        <div className="view-asset__title">
          <Title>View {itemLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="view-asset__form row g-0">
          <div className="col">
            <div className="view-asset__form--header">
              <h4>{itemLabel} Details</h4>
            </div>
            {StockEntry.WithoutPurchase.ViewAsset.map(
              (label: LabelProps, index: React.Key) => {
                return (
                  <div className="label-grid">
                    <Label>{label.labelName}</Label>
                    <Input value={formState[label.inputName]} disabled />
                  </div>
                );
              }
            )}
          </div>
          <div className="col">
            <div className="view-asset__form--header">
              <h4>{itemLabel} Configurations</h4>
            </div>

            {/* Require query from backend for this section */}
            <ul className="view-asset__form--header--ul">
              {data
                ? enabledConfigs.map((config, index) => {
                    return (
                      <li>
                        <span>
                          {index + 1}. {config.label}.
                        </span>
                        <div>
                          <img src={Yes} alt="" /> Yes
                        </div>
                      </li>
                    );
                  })
                : null}
            </ul>
          </div>
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default ViewAsset;
